import React from "react";
import SEOLandingPage from "./SEOLandingPage";

const JsonFormatterAndroid: React.FC = () => (
  <SEOLandingPage
    title="JSON Formatter for Android — Beautify & Validate JSON on Mobile | Cosmovex"
    metaDescription="Format, validate, and explore JSON on Android. Tree view, minifier, syntax errors, offline. Perfect for API responses on the go. Free on Google Play."
    ogTitle="JSON Formatter for Android — JSONVEdit"
    h1="JSON Formatter for Android"
    intro="Paste a raw JSON string and get it formatted, validated, and visualized in seconds. JSONVEdit is the JSON formatter Android developers actually want — tree view, error detection, minifier, all offline."
    paragraphs={[
      "Raw API responses are painful to read on a phone. JSONVEdit formats any JSON string with proper indentation and line breaks so the structure is instantly clear. Paste from clipboard, open a .json file, or type directly — it formats as you go with real-time validation.",
      "The tree view turns nested JSON into an expandable and collapsible structure. Objects and arrays show their keys and lengths before you open them. This makes navigating deeply nested API responses — the kind with 5 levels of nesting and arrays of objects — fast and readable on a small screen.",
      "Validation catches syntax errors the moment they appear: missing commas, unmatched brackets, invalid escape sequences, trailing commas. The error message points to the exact line and character so you can fix it without scanning the whole document. JSONVEdit also validates against JSON Schema if you need stricter type checking.",
      "The minifier works in the other direction — strip all whitespace to get a compact JSON string ready to copy into a POST body, config file, or environment variable. JSONVEdit handles JSON objects up to several megabytes, making it useful not just for quick checks but also for large data exports from backend systems.",
    ]}
    features={[
      "Format and beautify JSON with one tap",
      "Real-time validation with exact error location",
      "Expandable tree view for nested objects and arrays",
      "Minify JSON to compact single-line format",
      "Search and filter keys within large JSON objects",
      "Syntax highlighting for keys, strings, numbers, and booleans",
      "Open .json files directly from file manager or cloud storage",
      "Copy formatted or minified output to clipboard",
      "Works fully offline — no data sent to any server",
      "Handles large JSON files with smooth scrolling",
    ]}
    playStoreUrl="https://play.google.com/store/apps/details?id=com.cosmovex.jsonvedit"
    icon="/images/jsonvedit.png"
    appName="JSONVEdit"
    accentColor="#A8720E"
    canonicalPath="/json-formatter-android"
  />
);

export default JsonFormatterAndroid;
